import { useQuery } from '@tanstack/react-query';
import { workLogKeys } from '@/entities/work-log';
import { fetchWorkLogCount } from '../api';

export function useWorkLogCount(userId: string | undefined) {
  return useQuery({
    queryKey: workLogKeys.count(userId),
    queryFn: () => fetchWorkLogCount(),
    enabled: !!userId,
    staleTime: 30_000,
  });
}
